import type { SplashFragment } from "@server/gql/graphql";

export function extractHrefToSlugWithLinkParams(href: SplashFragment["href"]) {
  if (href?.__typename === "NavigationLink") {
    const linkParams = href.linkParams ?? "";

    if (href.externalLink) {
      return href.externalLink + linkParams;
    }

    if (href.internalLink?.slug) {
      return href.internalLink.slug + linkParams;
    }

    return undefined;
  }

  if (href?.slug) {
    return href.slug;
  }

  return undefined;
}
